import React from 'react';
// Import Helmet for managing the document head

import QuizSubjectPage from '../subjects/QuizSubjectPage';

function Quiz() {

 

  return (

    <>
      

      {/* **H1 Tag / Main Content Element Optimization** */}
      <QuizSubjectPage 
        // Optimized name for the main H1 heading on the page
        name="NEET Mock Test Series 2025 (Full, Subject & Topic Wise)" 
        link="quiz" 
        type="quiz" 
        subject="atoz" 
        topic="atoz" 
        subjectName="All subjects" 
      />

      {/* **CONTENT IDEA: Add an introductory paragraph below the H1**
          <div className="mock-test-intro">
             <p>Simulate the real NEET exam experience with our comprehensive mock test series. Choose from full-syllabus tests, or focus on specific areas with our subject and topic-wise mock quizzes.</p>
          </div>
      */}
    </>
  );
}

export default Quiz;